import { type TableCell } from '~/shared/ui/Table';

export enum OrderTableColumn {
    ID = 'ID',
    CREATED_AT = 'Дата создания',
    REQUISITE = 'Реквизиты',
    AMOUNT = 'Сумма',
    CURRENCY = 'Валюта',
    RATE = 'Курс',
    STATUS = 'Статус',
    EXPIRES_AT = 'До истечения',
}

export const orderTableHeaders: TableCell[] = [
    {
        key: OrderTableColumn.ID,
        content: OrderTableColumn.ID,
    },
    {
        key: OrderTableColumn.CREATED_AT,
        content: OrderTableColumn.CREATED_AT,
    },
    {
        key: OrderTableColumn.REQUISITE,
        content: OrderTableColumn.REQUISITE,
    },
    {
        key: OrderTableColumn.AMOUNT,
        content: OrderTableColumn.AMOUNT,
    },
    {
        key: OrderTableColumn.CURRENCY,
        content: OrderTableColumn.CURRENCY,
    },
    {
        key: OrderTableColumn.RATE,
        content: OrderTableColumn.RATE,
    },
    {
        key: OrderTableColumn.STATUS,
        content: OrderTableColumn.STATUS,
    },
    {
        key: OrderTableColumn.EXPIRES_AT,
        content: OrderTableColumn.EXPIRES_AT,
    },
];
